package net.frozenbit.games.soundgame.ui

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import net.frozenbit.games.soundgame.ProjectVersion
import net.frozenbit.games.soundgame.theme.Typography
import org.jetbrains.compose.resources.stringResource
import soundgame.app.shared.generated.resources.Res
import soundgame.app.shared.generated.resources.host_screen_start_button

@Composable
internal fun HostPreGameScreen(
    loading: Boolean,
    onStartGameClick: () -> Unit,
) {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        if (loading) {
            CircularProgressIndicator()
        } else {
            Button(onClick = { onStartGameClick() }) {
                Text(
                    stringResource(Res.string.host_screen_start_button),
                    fontSize = Typography.Host.titleSize,
                )
            }
        }
        Text(
            "v" + ProjectVersion.VALUE,
            modifier = Modifier.align(Alignment.BottomStart)
        )
    }
}